/**
 * Window event `initPostHog()` dispatches once its `loaded` callback has
 * settled consent, so `lib/analytics.ts` can replay the captures it held
 * while the SDK was still uninitialized. Lives in its own module because
 * `@/lib/posthog` is `vi.mock`ed with hand-written factories across the
 * test suite, which would not carry a new export.
 */
export const POSTHOG_LOADED_EVENT = "ahead:posthog-loaded"
